import { Actions, State, ActionType } from './types';
import {
  remoteResourceInitialState,
  remoteResourceLoadFailure,
  remoteResourceLoading,
  remoteResourceLoadSuccess,
} from '../../helpers';

const initialState: State = {
  report: remoteResourceInitialState([]),
  appliedCountryCode: '',
  filters: {
    countryCode: '',
    startDate: null,
    endDate: null,
  },
};

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionType.managementReportRequested:
      return {
        ...state,
        appliedCountryCode: state.filters.countryCode,
        report: remoteResourceLoading([]),
      };

    case ActionType.managementReportSuccess:
      return {
        ...state,
        report: remoteResourceLoadSuccess(action.data),
      };

    case ActionType.managementReportFailure:
      return {
        ...state,
        report: remoteResourceLoadFailure([], action.error),
      };

    case ActionType.managementChangeFilterCountry: {
      const prevCode = state.filters.countryCode;
      const nextCode = action.countryCode;

      if (prevCode === nextCode) return state;

      if (!nextCode || nextCode === state.appliedCountryCode) {
        return {
          ...state,
          filters: { ...state.filters, countryCode: nextCode },
        };
      }

      return {
        ...state,
        filters: { ...state.filters, countryCode: nextCode },
        report: remoteResourceInitialState([]),
      };
    }

    case ActionType.managementChangeFilterStartDate: {
      const prevStart = state.filters.startDate
        ? new Date(state.filters.startDate).getTime()
        : null;
      const nextStart = action.date ? new Date(action.date).getTime() : null;

      if (prevStart === nextStart) return state;

      return {
        ...state,
        filters: { ...state.filters, startDate: action.date },
        report: remoteResourceInitialState([]),
      };
    }

    case ActionType.managementChangeFilterEndDate: {
      const prevEnd = state.filters.endDate ? new Date(state.filters.endDate).getTime() : null;
      const nextEnd = action.date ? new Date(action.date).getTime() : null;

      if (prevEnd === nextEnd) return state;

      return {
        ...state,
        filters: { ...state.filters, endDate: action.date },
        report: remoteResourceInitialState([]),
      };
    }

    default:
      return state;
  }
};

export default reducer;
